import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { isUndefined, isNull } from 'lodash';
import ScrollContainer from 'react-indiana-drag-scroll';
import { StudentDetailsModal } from 'shared/components';
import { REGISTRATION_TYPES, DATE_FORMATS } from 'shared/constants';
import AccomodationIcon from 'assets/svgs/accomodationIconBlack.svg';
import StandByIcon from 'assets/svgs/standbyIconBlack.svg';
import LeftHandedIcon from 'assets/svgs/leftHandedIconBlack.svg';
import OnlineIcon from 'assets/svgs/onlineIconBlack.svg';
import InfoIcon from 'assets/svgs/info.svg';
import MismatchIcon from 'assets/svgs/mismatchIcon.svg';

import './RostersList.scss';

const findSelectedExaminee = (list) => {
  const examinee = list.find((exam) => exam.checked);

  return examinee ? +examinee.id : '';
};

const isTouchScreen =
  'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

class RostersList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      examineesList: props.locationEventExaminees,
      selectAll: false,
      selectedSingleExaminee: props.singleRoom
        ? findSelectedExaminee(props.locationEventExaminees)
        : null,
      modalIsOpen: false,
      selectedExaminee: {},
    };

    this.toggleScroll = this.toggleScroll.bind(this);
    this.toggleSticky = this.toggleSticky.bind(this);
    this.toggleScrollTable = this.toggleScrollTable.bind(this);
    this.removeSticky = this.removeSticky.bind(this);
    this.onSelectExaminee = this.onSelectExaminee.bind(this);
    this.onSelectSingleRoomExaminee = this.onSelectSingleRoomExaminee.bind(this);
    this.showExamineeDetails = this.showExamineeDetails.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const section = document.getElementsByClassName('scrollable-roster-list')[0];
    window.addEventListener('scroll', this.toggleSticky);
    section.addEventListener('scroll', this.toggleScroll);

    const sticky = document.getElementsByClassName('sticky-element')[0];
    const newDiv = document.createElement('div');

    newDiv.className = 'header-sticky';
    sticky.appendChild(newDiv);
    newDiv.addEventListener('scroll', this.toggleScrollTable);

    Array.from(document.querySelectorAll('.name-details')).forEach((el) => {
      const popover = bootstrap.Popover.getOrCreateInstance(el);
      if (isTouchScreen) {
        popover.disable();
      } else {
        popover.enable();
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.locationEventExaminees !== this.props.locationEventExaminees ||
      prevProps.singleRoom !== this.props.singleRoom
    ) {
      this.setState({
        examineesList: this.props.locationEventExaminees.concat([]),
        selectAll: !this.props.locationEventExaminees.some((examinee) => !examinee.checked),
        selectedSingleExaminee: this.props.singleRoom
          ? findSelectedExaminee(this.props.locationEventExaminees)
          : null,
      });
    }

    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).enable()
    );
    Array.from(document.querySelectorAll('.name-details')).forEach((el) => {
      const popover = bootstrap.Popover.getOrCreateInstance(el);
      if (isTouchScreen) {
        popover.disable();
      } else {
        popover.enable();
      }
    });
  }

  componentWillUnmount() {
    this.removeSticky();
  }

  toggleScrollTable() {
    const section = document.getElementsByClassName('header-sticky')[0];
    if (section.hasChildNodes()) {
      document.getElementsByClassName('scrollable-roster-list')[0].scroll(section.scrollLeft, 0);
    }
  }

  toggleScroll() {
    const section = document.getElementsByClassName('scrollable-roster-list')[0];
    document.getElementsByClassName('header-sticky')[0].scroll(section.scrollLeft, 0);
  }

  toggleSticky() {
    const section = document.getElementsByClassName('scrollable-roster-list')[0];
    const header = document.getElementsByClassName('table-header-roster')[0];
    let newHeader = header.cloneNode(true);
    newHeader.className = `${newHeader.className} clone-header`;

    if (section.getBoundingClientRect().top <= 0 && document.body.clientWidth < 1200) {
      const toAppendSection = document.getElementsByClassName('header-sticky')[0];
      if (!toAppendSection.hasChildNodes()) {
        toAppendSection.appendChild(newHeader);
        this.toggleScroll();
      }
    } else if (document.getElementsByClassName('clone-header')[0]) {
      const toRemoveFrom = document.getElementsByClassName('header-sticky')[0];
      toRemoveFrom.removeChild(document.getElementsByClassName('clone-header')[0]);
    }
  }

  removeSticky() {
    const section = document.getElementsByClassName('sticky-element')[0];
    const child = document.getElementsByClassName('header-sticky')[0];

    if (child) {
      child.removeEventListener('scroll', this.toggleScrollTable);
      section.removeChild(child);
    }

    document
      .getElementsByClassName('scrollable-roster-list')[0]
      .removeEventListener('scroll', this.toggleScroll);
    window.removeEventListener('scroll', this.toggleSticky);
  }

  onSelectExaminee(e) {
    const { examineesList } = this.state;
    const { value, checked } = e.target;
    const list = this.props.listOfSelectedExaminees.concat([]);

    const idx = examineesList.findIndex((elem) => elem.id === +value);
    examineesList[idx].checked = checked;
    if (!checked) {
      this.setState({
        selectAll: false,
      });
      list.splice(
        list.findIndex((el) => el.id === +value),
        1
      );
    } else {
      this.setState({
        selectAll: !examineesList.some((ex) => !ex.checked),
      });
      list.push(examineesList[idx]);
    }

    this.props.onUpdateSelectedExaminees(list);
  }

  onSelectSingleRoomExaminee(e) {
    const { examineesList } = this.state;
    const { value } = e.target;
    const list = this.props.listOfSelectedExaminees.concat([]);

    list[0] = examineesList.find((elem) => elem.id === +value);

    this.props.onUpdateSelectedExaminees(list);
  }

  showExamineeDetails(examinee) {
    this.setState({
      modalIsOpen: true,
      selectedExaminee: examinee,
    });
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
    });
  }

  getDeniedStatus = (denied) => {
    let reason = denied;
    if (reason === 'other') {
      reason = '';
    }
    if (reason === 'no_id') {
      return this.props.t('rosters.noId');
    }

    return reason ? `${reason.charAt(0).toUpperCase()}${reason.slice(1)}` : '';
  };

  render() {
    const { singleRoom, dateAvailable, visibleColumns, onSelectAll, hasNowManagedFlag } =
      this.props;
    const { examineesList, selectAll, selectedSingleExaminee } = this.state;

    const isBYODVisible = visibleColumns.find((c) => c.key === 'byod')?.checked;
    const isHsCodeVisible = visibleColumns.find((c) => c.key === 'hsCode')?.checked;
    const isMatchIdVisible = visibleColumns.find((c) => c.key === 'matchID')?.checked;
    const isTestDateVisible =
      dateAvailable && visibleColumns.find((c) => c.key === 'testDate')?.checked;
    const isRoomAssignedVisible = visibleColumns.find((c) => c.key === 'roomAssigned')?.checked;
    const isExamTypeVisible = visibleColumns.find((c) => c.key === 'examType')?.checked;
    const isTimingVisible = visibleColumns.find((c) => c.key === 'timing')?.checked;

    return (
      <div className="roster-list-container">
        <ScrollContainer className="scrollable-roster-list" hideScrollbars={false}>
          <table cellSpacing="0" className="roster-table">
            <tr className={`table-header-roster ${dateAvailable ? 'extra-col' : ''}`}>
              <th className="table-cell-roster">
                {!singleRoom && (
                  <div className="input-group">
                    <input
                      type="checkbox"
                      name="selectAllExaminees"
                      id="selectAllExaminees"
                      onChange={onSelectAll}
                      checked={selectAll}
                    />
                    <label htmlFor="selectAllExaminees"></label>
                  </div>
                )}
              </th>
              <th className="table-cell-roster">
                {!singleRoom && this.props.t('rosters.tableHeaders.selectAll')}
              </th>
              {isTestDateVisible && (
                <th className="table-cell-roster test-date-cell hide-desktop">
                  {this.props.t('rosters.tableHeaders.testDate')}
                </th>
              )}
              {isRoomAssignedVisible && (
                <th className="table-cell-roster room-assigned-cell hide-desktop">
                  {this.props.t('rosters.tableHeaders.roomAssigned')}
                </th>
              )}
              {isHsCodeVisible && (
                <th className="table-cell-roster">{this.props.t('rosters.tableHeaders.hsCode')}</th>
              )}
              {isMatchIdVisible && (
                <th className="table-cell-roster match-id-cell">
                  {this.props.t('rosters.tableHeaders.matchID')}
                </th>
              )}
              {isExamTypeVisible && (
                <th className="table-cell-roster exam-type-cell">
                  {this.props.t('rosters.tableHeaders.examType')}
                </th>
              )}
              {isTimingVisible && (
                <th className="table-cell-roster exam-timing-cell">
                  {this.props.t('rosters.tableHeaders.timing')}
                </th>
              )}
              {isTestDateVisible && (
                <th className="table-cell-roster test-date-cell show-desktop">
                  {this.props.t('rosters.tableHeaders.testDate')}
                </th>
              )}
              {isRoomAssignedVisible && (
                <th className="table-cell-roster room-assigned-cell show-desktop">
                  {this.props.t('rosters.tableHeaders.roomAssigned')}
                </th>
              )}
              {isBYODVisible && (
                <th className="table-cell-roster byod-cell">
                  {this.props.t('rosters.tableHeaders.byod')}
                </th>
              )}
            </tr>

            {examineesList.map((examinee) => (
              <tr
                key={examinee.id}
                className={`table-row-roster ${dateAvailable ? 'extra-col' : ''}`}>
                <td className="table-cell-roster">
                  {!singleRoom ? (
                    <div className="input-group">
                      <input
                        type="checkbox"
                        name={`examinee-${examinee.id}`}
                        id={examinee.id}
                        value={examinee.id}
                        onChange={this.onSelectExaminee}
                        checked={examinee.checked}
                      />
                      <label htmlFor={examinee.id}></label>
                    </div>
                  ) : (
                    <div className="form-check">
                      <input
                        type="radio"
                        name={`examinee-${examinee.id}`}
                        id={examinee.id}
                        value={examinee.id}
                        onChange={this.onSelectSingleRoomExaminee}
                        checked={examinee.id === selectedSingleExaminee}
                      />
                      <label htmlFor={examinee.id}></label>
                    </div>
                  )}
                </td>
                <td
                  className="table-cell-roster name-cell"
                  onClick={() => this.showExamineeDetails(examinee)}>
                  <div
                    tabIndex="0"
                    className="ellipsis-name btn-link name-details text-ellipsis"
                    data-bs-toggle="popover"
                    data-bs-placement="top"
                    data-bs-trigger="hover"
                    data-bs-content={examinee.name}
                    ref={(textElementRef) => {
                      if (textElementRef) {
                        textElementRef.classList.add(
                          textElementRef.firstChild?.scrollWidth >
                            textElementRef.firstChild?.clientWidth
                            ? 'enable'
                            : 'disable'
                        );
                      }
                    }}>
                    <div>{examinee.name}</div>
                  </div>
                  <div className="">
                    {examinee.absentFlag && (
                      <div tabIndex="0" className="denied-absent d-inline-block">
                        {this.props.t('rosters.absent')}
                      </div>
                    )}
                    {examinee.deniedReason && (
                      <div
                        tabIndex="0"
                        className="denied-absent d-inline-block"
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-boundary="window"
                        data-bs-html
                        data-bs-content={`<div>
                        <div>${this.getDeniedStatus(examinee.deniedReason)}</div>
                        <div>${this.getDeniedStatus(examinee.deniedReasonDetails)}</div>
                    </div>`}>
                        {this.props.t('rosters.denied')}
                      </div>
                    )}
                    {examinee.standByFlag && (
                      <div
                        tabIndex="0"
                        className="icons d-inline-block"
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-boundary="window"
                        data-bs-content={this.props.t('rosters.tooltipStandBy')}>
                        <StandByIcon />
                      </div>
                    )}
                    {examinee.onlineFlag && (
                      <div
                        tabIndex="0"
                        className="icons d-inline-block"
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-boundary="window"
                        data-bs-content={this.props.t('rosters.tooltipOnline')}>
                        <OnlineIcon />
                      </div>
                    )}
                    {examinee.accomRosterFlag && (
                      <div
                        tabIndex="0"
                        className="icons d-inline-block"
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-boundary="window"
                        data-bs-content={this.props.t('rosters.tooltipAccomodation')}>
                        <AccomodationIcon />
                      </div>
                    )}
                    {examinee.leftHandedFlag && (
                      <div
                        tabIndex="0"
                        className="icons d-inline-block"
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-boundary="window"
                        data-bs-content={this.props.t('rosters.tooltipLeftHand')}>
                        <LeftHandedIcon />
                      </div>
                    )}
                    {(examinee.timingIncompatibility ||
                      examinee.roomTypeIncompatibility ||
                      examinee.singleRoomIncompatibility) && (
                      <div
                        tabIndex="0"
                        className="icons d-inline-block warning-icon"
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-bs-boundary="window"
                        data-bs-html={true}
                        data-bs-content={this.props.t('rosters.tooltipMismatch')}>
                        <MismatchIcon />
                      </div>
                    )}
                  </div>
                </td>
                {isTestDateVisible && (
                  <td className="table-cell-roster test-date-cell  hide-desktop">
                    {examinee.scheduledDate
                      ? moment(examinee.scheduledDate).format(DATE_FORMATS.monthShortDayYear)
                      : ''}
                  </td>
                )}
                {isRoomAssignedVisible && (
                  <td
                    className={`table-cell-roster room-assigned-cell hide-desktop ${
                      !isNull(examinee.roomName) && !isUndefined(examinee.roomName) ? 'fw-bold' : ''
                    }`}>
                    <div className="text-truncate">
                      {!isNull(examinee.roomName) && !isUndefined(examinee.roomName)
                        ? examinee.roomName
                        : this.props.t('common.labels.notAssigned')}
                    </div>
                  </td>
                )}

                {isHsCodeVisible && <td className="table-cell-roster">{examinee.hsCode}</td>}
                {isMatchIdVisible && (
                  <td className="table-cell-roster match-id-cell">{examinee.matchId}</td>
                )}
                {isExamTypeVisible && (
                  <td className="table-cell-roster exam-type-cell">
                    {examinee.regType}
                    {examinee.capacityType === REGISTRATION_TYPES.sectionRetest && (
                      <span
                        tabIndex="0"
                        className="icons ps-1"
                        data-bs-toggle="popover"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        data-bs-boundary="window"
                        data-bs-content={examinee.sectionList}>
                        <InfoIcon />
                      </span>
                    )}
                  </td>
                )}
                {isTimingVisible && (
                  <td className="table-cell-roster exam-timing-cell">{examinee.timing}</td>
                )}
                {isTestDateVisible && (
                  <td className="table-cell-roster test-date-cell show-desktop">
                    {examinee.scheduledDate
                      ? moment(examinee.scheduledDate).format(DATE_FORMATS.monthShortDayYear)
                      : ''}
                  </td>
                )}
                {isRoomAssignedVisible && (
                  <td
                    className={`table-cell-roster room-assigned-cell show-desktop ${
                      !isNull(examinee.roomName) && !isUndefined(examinee.roomName) ? 'fw-bold' : ''
                    }`}>
                    <div className="text-truncate">
                      {!isNull(examinee.roomName) && !isUndefined(examinee.roomName)
                        ? examinee.roomName
                        : this.props.t('common.labels.notAssigned')}
                    </div>
                  </td>
                )}
                {isBYODVisible && (
                  <td className={`table-cell-roster byod-cell show-desktop`}>
                    <div className="text-truncate">
                      {/byod/i.test(examinee.capacityType)
                        ? this.props.t('common.labels.yes')
                        : this.props.t('common.labels.no')}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </table>
        </ScrollContainer>
        <StudentDetailsModal
          student={this.state.selectedExaminee}
          modalIsOpen={this.state.modalIsOpen}
          closeModal={this.closeModal}
          nowManagedFlag={hasNowManagedFlag}
        />
      </div>
    );
  }
}

export default withTranslation()(RostersList);
RostersList.propTypes = {
  locationEventExaminees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      checked: PropTypes.bool,
      absentFlag: PropTypes.bool,
      deniedReason: PropTypes.string,
      deniedReasonDetails: PropTypes.string,
      standByFlag: PropTypes.bool,
      onlineFlag: PropTypes.bool,
      accomRosterFlag: PropTypes.bool,
      leftHandedFlag: PropTypes.bool,
      timingIncompatibility: PropTypes.bool,
      roomTypeIncompatibility: PropTypes.bool,
      singleRoomIncompatibility: PropTypes.bool,
      scheduledDate: PropTypes.string,
      roomName: PropTypes.string,
      hsCode: PropTypes.string,
      matchId: PropTypes.string,
      regType: PropTypes.string,
      capacityType: PropTypes.string,
      sectionList: PropTypes.string,
      timing: PropTypes.string,
    })
  ).isRequired,
  singleRoom: PropTypes.bool,
  dateAvailable: PropTypes.bool,
  visibleColumns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      checked: PropTypes.bool,
    })
  ).isRequired,
  onSelectAll: PropTypes.func.isRequired,
  hasNowManagedFlag: PropTypes.bool,
  listOfSelectedExaminees: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onUpdateSelectedExaminees: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
